export enum SiliconeColours {
  White,
  Transparent,
  Bronze,
}
